import React, { useEffect } from 'react';
import './Buy.scss';
import Header from '../Header';
import Footer from '../Footer';
import TelegramPopup from '../../Common/TelegramPopup/TelegramPopup';
import tradingImage from '../../../assets/reddickrednobackground.png';

const Buy = () => {
  // Reset scroll position when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Function to handle smooth scrolling to platforms section
  const scrollToPlatforms = (e) => {
    e.preventDefault();
    const platformsSection = document.getElementById('platforms-section');
    if (platformsSection) {
      platformsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="buy-page">
      <Header />

      <main className="buy-content">
        <section className="buy-hero-section">
          <div className="container">
            <h1>Buy REDDICKS</h1>
            <p className="subtitle">Trade on Radix's most liquid DEX with the lowest fees</p>
            <a 
              href="#platforms-section" 
              onClick={scrollToPlatforms}
              className="trade-button"
            >
              Trade Now
            </a>
          </div>
        </section>

        <section className="trading-section">
          <div className="container">
            <div className="trading-content">
              <div className="trading-image">
                <img src={tradingImage} alt="REDDICKS Trading" />
              </div>
              <div className="trading-info">
                <h2 className="section-title text-left">Leading Liquidity on Radix</h2>
                <p>REDDICKS boasts over $1 million in locked liquidity, ensuring stability and efficient trading.</p>
                
                <div className="info-card">
                  <h3>Best-in-Class Trading Experience</h3>
                  <p>With just 0.05% trading fees, REDDICKS offers one of the lowest trading costs in the entire Radix ecosystem, making it perfect for both small and large trades.</p>
                </div>
                
                <div className="info-card">
                  <h3>Highest Liquidity Altcoin</h3>
                  <p>REDDICKS is the altcoin with the most liquidity on the Radix network, backed by over $1 million in locked liquidity, allowing even the largest wallets to trade with minimal slippage and optimal execution.</p>
                </div>
                
                <div className="info-card">
                  <h3>Growing Liquidity Pool</h3>
                  <p>The REDDICKS team is committed to continuously expanding the liquidity pool through dedicated team funding and innovative community initiatives.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="platforms-section" id="platforms-section">
          <div className="container">
            <h2 className="section-title">Available Trading Platforms</h2>
            <div className="platforms-grid">
              <div className="platform-card featured">
                <h3>CaviarNine</h3>
                <div className="platform-badges">
                  <span className="platform-badge">Most Liquidity</span>
                  <span className="platform-badge">Lowest Fees</span>
                  <span className="platform-badge">DEX</span>
                </div>
                <p>Leading DEX on Radix with the deepest liquidity for REDDICKS.</p>
                <a 
                  href="https://www.caviarnine.com/trade" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="platform-link"
                >
                  Trade on CaviarNine
                </a>
              </div>
              
              <div className="platform-card">
                <h3>Astrolescent</h3>
                <div className="platform-badges">
                  <span className="platform-badge secondary">🔥 Bridge from SOL and other chains 🔥</span>
                  <span className="platform-badge secondary">Aggregator</span>
                  <span className="platform-badge secondary">DEX</span>
                </div>
                <p>DEX aggregator and cross-chain bridge for the Radix network.</p>
                <a 
                  href="https://astrl.trade/token/reddicks" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="platform-link"
                >
                  Trade on Astrolescent
                </a>
              </div>
              
              <div className="platform-card">
                <h3>Ociswap</h3>
                <div className="platform-badges">
                  <span className="platform-badge">DEX</span>
                </div>
                <p>Automated market maker (AMM) on the Radix network.</p>
                <a 
                  href="https://ociswap.com/resource_rdx1t42hpqvsk4t42l6aw09hwphd2axvetp6gvas9ztue0p30f4hzdwxrp" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="platform-link"
                >
                  Trade on Ociswap
                </a>
              </div>
              
              <div className="platform-card">
                <h3>Calamari</h3>
                <div className="platform-badges">
                  <span className="platform-badge">DEX</span>
                </div>
                <p>Tentacle-powered trading, DEX optimizer for the Radix network.</p>
                <a 
                  href="https://www.8arms1goal.com/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="platform-link"
                >
                  Trade on Calamari
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="benefits-section">
          <div className="container">
            <h2 className="section-title">Reddicks Trading Benefits</h2>
            <div className="benefits-grid">
              <div className="benefit">
                <div className="benefit-icon fees"></div>
                <h3>Ultra-Low Fees</h3>
                <p>Only 0.05% trading fee, positioning REDDICKS among the most cost-effective trading options on Radix.</p>
              </div>
              
              <div className="benefit">
                <div className="benefit-icon liquidity"></div>
                <h3>Deep Liquidity</h3>
                <p>Significant liquidity depth, with over $1 million locked, ensures minimal price impact for trades of all sizes.</p>
              </div>
              
              <div className="benefit">
                <div className="benefit-icon security"></div>
                <h3>Secure Trading</h3>
                <p>Trade directly on Radix's highly secure decentralized exchange infrastructure.</p>
              </div>
              
              <div className="benefit">
                <div className="benefit-icon growth"></div>
                <h3>Expanding Ecosystem</h3>
                <p>Join a rapidly growing ecosystem with continuous improvements and expanding utility.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="trading-strategy-section">
          <div className="container">
            <h2 className="section-title">Liquidity Roadmap</h2>
            <div className="strategy-content">
              <div className="strategy-info">
                <p>The REDDICKS team has implemented a strategic liquidity growth plan, supported by over $1 million in locked liquidity, to ensure the token remains the most liquid altcoin on the Radix network.</p>
                <p>Our liquidity expansion strategy includes:</p>
                
                <ul className="strategy-list">
                  <li>
                    <span className="list-icon"></span>
                    <div className="list-content">
                      <h4>Team-Backed Liquidity</h4>
                      <p>Continuous injection of team funds to deepen the liquidity pool and reduce slippage for traders.</p>
                    </div>
                  </li>
                  
                  <li>
                    <span className="list-icon"></span>
                    <div className="list-content">
                      <h4>Community Liquidity Programs</h4>
                      <p>Innovative incentives for community members who contribute to the liquidity pool, creating a collaborative approach to market depth.</p>
                    </div>
                  </li>
                  
                  <li>
                    <span className="list-icon"></span>
                    <div className="list-content">
                      <h4>Strategic Partnerships</h4>
                      <p>Forming alliances with key projects in the Radix ecosystem to create cross-project liquidity initiatives.</p>
                    </div>
                  </li>
                  
                  <li>
                    <span className="list-icon"></span>
                    <div className="list-content">
                      <h4>Treasury Allocations</h4>
                      <p>Dedicated portions of the REDDICKS treasury are regularly allocated to enhance trading liquidity.</p>
                    </div>
                  </li>
                </ul>
                
                <div className="cta-container">
                  <p className="cta-text">Start trading REDDICKS today with the lowest fees and highest liquidity (over $1 million locked) on Radix.</p>
                  <a 
                    href="#platforms-section" 
                    onClick={scrollToPlatforms}
                    className="trade-button"
                  >
                    Buy REDDICKS
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <TelegramPopup />
    </div>
  );
};

export default Buy; 